export default __webpack_public_path__ + "media/Meat-Pork.5119a5ab.png";